import {
  IAction,
  IComponentVolumes,
  ICountry,
  ILang,
  IModal,
  IOilFilter,
  IRecommendations,
  ISearchProduct,
  ISearchVehicle,
  IServiceIntervals,
  ITWorkshop,
  IWorkshop,
  LocationCategory,
  LocationType,
  ProductCategory,
  Replacement,
} from '../interface';
import { actionTypes } from './actions';

const initOilFilter: IOilFilter = {
  vehicle: undefined,
  productCategories: [],
  locationCategories: [],
  oils: [],
  address: undefined,
  openHours: 0,
  closeHours: 0,
  locationType: [],
  distance: undefined,
};

export const oilFilterReducer = (
  state: IOilFilter = initOilFilter,
  action: IAction,
) => {
  switch (action.type) {
    case actionTypes.SET_VEHICLE:
      return { ...state, ...{ vehicle: action.vehicle } };
    case actionTypes.SET_PRODUCTCATEGORIES:
      return { ...state, ...{ productCategories: action.productCategories } };
    case actionTypes.SET_LOCATIONCATEGORIES:
      return { ...state, ...{ locationCategories: action.locationCategories } };
    case actionTypes.SET_OILS:
      return { ...state, ...{ oils: action.oils } };
    case actionTypes.SET_ADDRESS:
      return { ...state, ...{ address: action.address } };
    case actionTypes.SET_WORKSHOP_LOW_RATING:
      return { ...state, ...{ workshopLowRating: action.workshopLowRating } };
    case actionTypes.SET_WORKSHOP_UP_RATING:
      return { ...state, ...{ workshopUpRating: action.workshopUpRating } };
    case actionTypes.SET_OPEN_HOURS:
      return { ...state, ...{ openHours: action.openHours } };
    case actionTypes.SET_CLOSE_HOURS:
      return { ...state, ...{ closeHours: action.closeHours } };
    case actionTypes.SET_LOCATION_TYPE:
      return { ...state, ...{ locationType: action.locationType } };
    case actionTypes.SET_DISTANCE:
      return { ...state, ...{ distance: action.distance } };
    default:
      return state;
  }
};

const initSort = 'distanceInMiles';

export const sortReducer = (state: string = initSort, action: IAction) => {
  if (action.type === actionTypes.SET_SORT) {
    return action.sort;
  } else {
    return state;
  }
};

export const workshopReducer = (state: IWorkshop[] = [], action: IAction) => {
  if (action.type === actionTypes.SET_WORKSHOPS) {
    return [...action.workshops];
  } else {
    return state;
  }
};

export const modalReducer = (
  state: IModal = { visibie: false, href: 0 },
  action: IAction,
) => {
  if (action.type === actionTypes.SET_MODAL) {
    return action.modal;
  } else {
    return state;
  }
};

const InitLang = '';

export const langReducer = (state: string = InitLang, action: IAction) => {
  if (action.type === actionTypes.SET_LANG) {
    return action.lang;
  } else {
    return state;
  }
};

export const countryReducer = (
  state: ICountry = {
    id: 0,
    name: '',
    isoCode: '',
    defaultLanguage: { name: '', isoCode: '' },
  },
  action: IAction,
) => {
  if (action.type === actionTypes.SET_COUNTRY) {
    return action.country;
  } else {
    return state;
  }
};

export const countriesReducer = (state: ICountry[] = [], action: IAction) => {
  if (action.type === actionTypes.SET_COUNTRIES) {
    return action.countries;
  } else {
    return state;
  }
};

export const replacementReducer = (
  state: Replacement = {},
  action: IAction,
) => {
  if (action.type === actionTypes.SET_REPLACEMENTS) {
    return action.replacements;
  } else {
    return state;
  }
};

export const serviceIntervalsReducer = (
  state: IServiceIntervals[] = [],
  action: IAction,
) => {
  if (action.type === actionTypes.SET_SERVICEINTERVALS) {
    return action.serviceIntervals;
  } else {
    return state;
  }
};

export const vehicleComponentVolumesReducer = (
  state: IComponentVolumes[] = [],
  action: IAction,
) => {
  if (action.type === actionTypes.SET_COMPONENTVOLUMES) {
    return action.vehicleComponentVolumes;
  } else {
    return state;
  }
};

export const langsReducer = (state: ILang[] = [], action: IAction) => {
  if (action.type === actionTypes.SET_LANGS) {
    return action.langs;
  } else {
    return state;
  }
};

export const selectedLocationReducer = (
  state: ITWorkshop | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_SELECTEDLOCATION) {
    return action.selectedLocation;
  } else {
    return state;
  }
};

export const whereToBuyEnabledReducer = (
  state: boolean | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_WHERETOBUYENABLED) {
    return action.whereToBuyEnabled;
  } else {
    return state;
  }
};

export const locationTypesListReducer = (
  state: LocationType[] | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_LOCATIONTYPESLIST) {
    return action.locationTypesList;
  } else {
    return state;
  }
};

export const locationCategoriesListReducer = (
  state: LocationCategory[] | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_LOCATIONCATEGORIESLIST) {
    return action.locationCategoriesList;
  } else {
    return state;
  }
};

export const productCategoriesListReducer = (
  state: ProductCategory[] | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_PRODUCTCATEGORIESLIST) {
    return action.productCategoriesList;
  } else {
    return state;
  }
};

export const whereToServiceEnabledReducer = (
  state: boolean | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_WHERETOSERVICESENDABLED) {
    return action.whereToServiceEnabled;
  } else {
    return state;
  }
};

export const hasCastrolCertifiedWorkshopsReducer = (
  state = false,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_HASCASTROLCERTIFIEDWORKSHOPS) {
    return action.hasCastrolCertifiedWorkshops;
  } else {
    return state;
  }
};

export const enableWtbDistanceFilterReducer = (
  state = false,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_ENABLEWTBDISTANCEFILTER) {
    return action.enableWtbDistanceFilter;
  } else {
    return state;
  }
}

export const isMilesReducer = (
  state = false,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_ISMILES) {
    return action.isMiles;
  } else {
    return state;
  }
}

export const distanceInMilesOrKMReducer = (
  state = false,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_DISTANCEINMILESORKM) {
    return action.distanceInMilesOrKM;
  } else {
    return state;
  }
}

export const recommendedProductsReducer = (
  state: IRecommendations[] = [],
  action: IAction,
) => {
  if (action.type === actionTypes.SET_RECOMMENDEDPRODUCTS) {
    return action.recommendedProducts;
  } else {
    return state;
  }
};

export const resultsReducer = (
  state: ISearchVehicle[] | ISearchProduct[] | null = null,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_RESULTS) {
    return action.results;
  } else {
    return state;
  }
};

export const licenseKeysReducer = (
  state = '',
  action: IAction,
) => {
  if (action.type === actionTypes.SET_LICENSEKEYS) {
    return action.licenseKeys;
  } else {
    return state;
  }
};

export const loadingReducer = (
  state = false,
  action: IAction,
) => {
  if (action.type === actionTypes.SET_LOADING) {
    return action.loading;
  } else {
    return state;
  }
};

const initIsIreland = false;
 
export const isIrelandReducer = (
  state: boolean = initIsIreland,
  action: IAction
) => {
  if (action.type === actionTypes.SET_IS_IRELAND) {
    return action.isIreland;
  } else {
    return state;
  }
};